import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
var tenantConfigComponent = /** @class */ (function () {
    function tenantConfigComponent(tenantConfigService, toastr, vcr) {
        this.tenantConfigService = tenantConfigService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.resetDefaultsUrl = 'reset';
        this.tntConfData = {
            tenantConfigDataList: [],
            customScaleList: [],
            measureStatusIndicatorData: [],
            measureColorData: []
        };
        this.weekDayList = [
            'Monday', 'Tuesday', 'Wednesday',
            'Thursday', 'Friday', 'Saturday', 'Sunday'
        ];
        this.loader = false;
        this.mainPage = true;
        this.isEdit = false;
        this.accessDenied = false;
        this.xErrorMsg = '';
        this.xErrorMsg1 = '';
        this.tenantConfigList = [];
        this.customScaleList = [];
        this.measureColorData = [];
        this.colorPaletevalue = [];
        this.toastr.setViewRef(vcr);
    }
    tenantConfigComponent.prototype.ngOnInit = function () {
        if (this.tenantConfigService.isBIAdmin) {
            this.loadTenantConfigs();
        }
        else {
            this.accessDenied = true;
        }
    };
    tenantConfigComponent.prototype.loadTenantConfigs = function () {
        var self = this;
        self.loader = true;
        return new Promise(function (resolve) {
            self.tenantConfigService.onStartUp(BiUrls.TENANT_CONFIG).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('No Tenant Configurations to load');
                }
                self.tntConfData = res;
                self.setConfigList();
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the tenant configurations');
                }
            });
        });
    };
    tenantConfigComponent.prototype.editTenantConfig = function (event) {
        var self = this;
        self.mainPage = false;
        self.isEdit = true;
    };
    tenantConfigComponent.prototype.setConfigList = function () {
        var _this = this;
        this.customScaleList = [];
        this.tenantConfigList = [];
        this.measureColorData = [];
        var data = this.tntConfData.tenantConfigDataList;
        data.forEach(function (val) {
            if (val.type && val.type == 'SCALE') {
                if (typeof val.value == 'string') {
                    val.value = JSON.parse(val.value);
                }
                _this.customScaleList.push(val);
            }
            else if (val.key == "COLOR_PALETTE") {
                val.value = JSON.parse(val.value);
                _this.colorPaletevalue = [];
                val.value.forEach(function (value1) {
                    _this.colorPaletevalue.push(value1);
                });
                _this.measureColorData.push(_this.colorPaletevalue);
            }
            else if (val.key == "PAGE_SNAPSHOT_EXPIRY") {
                _this.dashboardExpiry = val;
            }
            else {
                _this.tenantConfigList.push(val);
            }
        });
        this.customScaleList.sort(function (a, b) {
            return +a.value.value - +b.value.value;
        });
    };
    tenantConfigComponent.prototype.getConfigType = function (config) {
        if (config.key == "WEEK_START_DAY") {
            return 1;
        }
        else if (config.key == "MONTH_START_DATE") {
            return 2;
        }
        else if (config.key == "YEAR_START_MONTH") {
            return 5;
        }
        else if (config.key == "FONT_SIZE") {
            return 6;
        }
        else if (config.key == "NEGATIVE"
            || config.key == "NEUTRAL"
            || config.key == "POSITIVE") {
            return 4;
        }
        else {
            return 3;
        }
    };
    tenantConfigComponent.prototype.addIndicators = function () {
        var self = this;
        var msrIndData = { name: '', value: null, code: '' };
        self.tntConfData.measureStatusIndicatorData.push(msrIndData);
    };
    tenantConfigComponent.prototype.addColorPalette = function () {
        var self = this;
        var value1 = { startcolor: '', endcolor: '' };
        this.colorPaletevalue.push(value1);
    };
    tenantConfigComponent.prototype.addColorPaletteToConfig = function () {
        // let self = this;
        this.measureColorData = {};
        var value = JSON.stringify(this.colorPaletevalue);
        this.measureColorData['key'] = "COLOR_PALETTE";
        this.measureColorData['displayName'] = "Color Palette";
        this.measureColorData['value'] = value;
    };
    tenantConfigComponent.prototype.addScales = function () {
        var self = this;
        var value = { code: "", value: "", type: "SCALE" };
        var scaleData = { displayName: '', key: '', type: 'SCALE', value: value, valueData: null, new: true };
        self.customScaleList.push(scaleData);
    };
    tenantConfigComponent.prototype.onIndicatorDelete = function (configIndex) {
        var self = this;
        self.tntConfData.measureStatusIndicatorData.splice(configIndex, 1);
    };
    tenantConfigComponent.prototype.onColorPaletteDelete = function (configIndex) {
        this.colorPaletevalue.splice(configIndex, 1);
    };
    tenantConfigComponent.prototype.onScaleDelete = function (configIndex) {
        this.customScaleList.splice(configIndex, 1);
    };
    tenantConfigComponent.prototype.onSave = function () {
        var self = this;
        self.loader = true;
        var validatedRes = self.validator();
        if (validatedRes != '') {
            self.toastr.showError(validatedRes);
            self.loader = false;
            self.isEdit = true;
        }
        else {
            self.setScaleKey();
            self.addColorPaletteToConfig();
            self.addPageConfig();
            self.tntConfData.tenantConfigDataList = self.tenantConfigList;
            self.tntConfData.tenantConfigDataList.push(self.measureColorData);
            (_a = self.tntConfData.tenantConfigDataList).push.apply(_a, self.customScaleList);
            self.tenantConfigService.save(BiUrls.TENANT_CONFIG, self.tntConfData).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('Unable to save tenant configurations.');
                }
                else {
                    self.toastr.showSuccess('Changes saved successfully.');
                }
                self.loader = false;
                self.mainPage = true;
                self.isEdit = false;
                self.loadTenantConfigs();
            });
        }
        var _a;
    };
    tenantConfigComponent.prototype.onResetDefaults = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            var url = BiUrls.TENANT_CONFIG + '/' + self.resetDefaultsUrl;
            _this.tenantConfigService.onStartUp(url).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('No Tenant Configurations to load');
                }
                else {
                    self.toastr.showSuccess('Default configurations restored successfully');
                }
                self.tntConfData = res;
                self.setConfigList();
                self.loader = false;
                self.mainPage = true;
                self.isEdit = false;
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the tenant configurations');
                }
            });
        });
    };
    tenantConfigComponent.prototype.validateDay = function (event, ind) {
        var self = this;
        var value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0 || value > 31) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg = 'Date should be from 1 to 31.';
        }
        else {
            self.xErrorMsg = '';
            this.tenantConfigList[ind].value = value;
        }
    };
    tenantConfigComponent.prototype.validateNumber = function (event, ind) {
        var self = this;
        var value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg = '';
        }
        else {
            self.xErrorMsg = '';
            this.tenantConfigList[ind].value = value;
        }
    };
    tenantConfigComponent.prototype.validateMonth = function (event, ind) {
        var self = this;
        var value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0 || value > 12) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg1 = 'Month should be from 1 to 12.';
        }
        else {
            self.xErrorMsg1 = '';
            this.tenantConfigList[ind].value = value;
        }
    };
    tenantConfigComponent.prototype.validator = function () {
        var self = this;
        var flag = false;
        var nameList = [];
        for (var _i = 0, _a = self.tenantConfigList; _i < _a.length; _i++) {
            var conf = _a[_i];
            if (conf.value === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            }
            else {
            }
        }
        for (var _b = 0, _c = self.customScaleList; _b < _c.length; _b++) {
            var conf = _c[_b];
            if (conf.displayName === '') {
                flag = true;
                return 'Scale display name cannot be empty.';
            }
            else if (conf.value.value === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            }
            else if (conf.value.code === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            }
            else if (nameList.includes(conf.displayName.trim())) {
                flag = true;
                return ' Display name cannot be same.';
            }
            else {
                nameList.push(conf.displayName);
            }
        }
        for (var _d = 0, _e = self.tntConfData.measureStatusIndicatorData; _d < _e.length; _d++) {
            var indicator = _e[_d];
            if (indicator.name === '') {
                flag = true;
                return 'Indicator scale field cannot be empty.';
            }
            else if (indicator.value === '') {
                flag = true;
                return indicator.name + ' value field cannot be empty.';
            }
            else {
            }
        }
        for (var _f = 0, _g = self.colorPaletevalue; _f < _g.length; _f++) {
            var colorpalette = _g[_f];
            if (colorpalette.startcolor === '') {
                flag = true;
                return 'start color value field cannot be empty.';
            }
            else if (colorpalette.endcolor === '') {
                flag = true;
                return 'end color value field cannot be empty.';
            }
            else {
            }
        }
        if (flag == false) {
            return '';
        }
    };
    tenantConfigComponent.prototype.onBack = function () {
        var self = this;
        self.loadTenantConfigs();
        self.mainPage = true;
        self.isEdit = false;
        //self.tntConfData = null;
    };
    tenantConfigComponent.prototype.setScaleKey = function () {
        var self = this;
        self.customScaleList.forEach(function (scale) {
            var key = scale.displayName.toUpperCase();
            if (scale.hasOwnProperty('new')) {
                if (key.match(/\s/g)) {
                    key = key.replace(/\s/g, '_');
                }
                key = 'NF_' + key;
                scale.key = key;
                delete scale.new;
            }
            else {
                key = 'NF_' + key;
                scale.key = key;
            }
            scale.value = JSON.stringify(scale.value);
        });
    };
    tenantConfigComponent.prototype.onSyncDash = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_PAGE_CACHE).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Cache Synced');
            }
            else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.onFlushDash = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.flushCacheConfig(BiUrls.FLUSH_CURRENT_TENANT_PAGE_CACHE).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Cache Flushed');
            }
            else {
                self.toastr.showError('Failed to Flush Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.onSyncData = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_DATA_VS).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Data Version Cache Synced');
            }
            else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.onSyncCube = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_CUBE_META).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Cube Meta Cache Synced');
            }
            else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.getWeekName = function (day) {
        return day[0].toUpperCase() + day.slice(1);
    };
    tenantConfigComponent.prototype.changeWeekStartDay = function (event, config) {
        config.value = event.target.value;
    };
    tenantConfigComponent.prototype.reBuildDashboardSnaphot = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.reBuildDashboardSnaphot(BiUrls.REBUILD_DASH_SNAPSHOT).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Snapshot Rebuilded Successfully');
            }
            else {
                self.toastr.showError('Dashboard Snapshot Rebuilded Failed');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.setExpiry = function (event) {
        if (this.dashboardExpiry) {
            this.dashboardExpiry.value = event.target.value;
        }
        else {
            this.dashboardExpiry = {
                displayName: "Page Snapshot Expiry",
                key: "PAGE_SNAPSHOT_EXPIRY",
                type: null,
                value: event.target.value
            };
        }
    };
    tenantConfigComponent.prototype.getValueFor = function () {
        if (this.dashboardExpiry) {
            return this.dashboardExpiry.value != undefined && this.dashboardExpiry.value != '' ? this.dashboardExpiry.value : 30;
        }
        else {
            return 30;
        }
    };
    tenantConfigComponent.prototype.addPageConfig = function () {
        var _this = this;
        if (this.dashboardExpiry) {
            var check_1 = false;
            this.tenantConfigList.forEach(function (config) {
                if (config.key == 'PAGE_SNAPSHOT_EXPIRY') {
                    check_1 = true;
                    config = {};
                    config = _this.dashboardExpiry;
                }
            });
            if (!check_1) {
                this.tenantConfigList.push(this.dashboardExpiry);
            }
        }
    };
    tenantConfigComponent.prototype.validateDuration = function (event) {
        if (event.charCode > 31 && (event.charCode < 48 || event.charCode > 57)) {
            return false;
        }
        if (event.target.value.length >= 3) {
            return false;
        }
    };
    return tenantConfigComponent;
}());
export { tenantConfigComponent };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/tenantConfiguration.component.ts.pre-build-optimizer.js